// const wordingConfig = {
//   projectName: "Victoria Insurance Life",
//   namaPusat: "Koperasi Pusat",
//   namaCabang: "Koperasi Primer",
// };

const wordingConfig = {
  projectName: "Bumi Insurance Broker",
  namaPusat: "Wilayah",
  namaCabang: "KC / KCP",
};

export default wordingConfig;
